import { PanelView } from 'owa-time-panel-view-stack';
import { getMailAriaTenantTokens } from 'owa-analytics';
import { CustomData } from 'owa-analytics-actions';

/* Custom data for drag and hover to switch time panel tabs functionality */
export interface HoverSwitchTabsCustomData {
    previousView: PanelView;
    nextView: PanelView;
}

/* Custom data for dragging and dropping emails into the time panel to create meetings */
export interface DropEscalateMeetingCustomData {
    dropTarget: DragEscalateMeetingTarget;
}

export type DragEscalateMeetingTarget =
    | 'AgendaViewDropBox'
    | 'CalendarTabDropFallback'
    | 'DayViewDropHintFallback'
    | 'DayViewSchedulingGrid';

/** Log unsampled datapoints (i.e. for 100% of users) in the shared OWA tenant */
export const timePanelDndOptions = {
    isCore: true,
    tenantTokens: getMailAriaTenantTokens(),
};

/**
 * Generates custom data for Time Panel DND datapoints
 */
export function getTimePanelDndCustomData<TCustomData>(
    datapointSpecificCustomData?: CustomData & TCustomData
): CustomData & TCustomData {
    return datapointSpecificCustomData;
}
